import React, { type ReactNode, Children } from "react";
import { AccordionItem } from "ui/accordion";

export function MdxAccordion({ children }: { children?: ReactNode }) {
  const arrayChildren = Children.toArray(children);
  const title = arrayChildren?.[0];
  const content = arrayChildren?.slice(1);

  return <AccordionItem title={title} content={content} />;
}
